export default "__VITE_ASSET__BK4dT$Ee__"